var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiscUploadPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 57V36",
    stroke: "#0088CC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4961 42L35.9971 35.499L42.4981 42",
    stroke: "#0088CC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9984 57H55.6784C61.4624 57 66.1784 52.284 66.1784 46.5C66.1784 40.716 61.4624 36 55.6784 36H54.3734V33C54.3734 23.07 46.3034 15 36.3734 15C27.4424 15 20.0384 21.534 18.6344 30.069C11.5034 30.432 5.81836 36.279 5.81836 43.5C5.81836 50.955 11.8634 57 19.3184 57H23.9984",
    stroke: "#0088CC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiscUploadPdf);
export default __webpack_public_path__ + "static/media/misc-uploadPDF.8282d8ef2c3396c34b6013d7bd5877cd.svg";
export { ForwardRef as ReactComponent };